var render = function render(){var _vm=this,_c=_vm._self._c;return _c('com-item',{attrs:{"name":"records.monthly","size":_vm.size,"loading":_vm.loading,"is-empty":!_vm.active,"title":"Activity"},scopedSlots:_vm._u([{key:"stats",fn:function(){return [(_vm.active)?_c('app-visualisation-bars',{attrs:{"data":_vm.graph}}):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }